import { render, staticRenderFns } from "./remainOld.vue?vue&type=template&id=6c2ac2a2&scoped=true&"
import script from "./remainOld.vue?vue&type=script&lang=js&"
export * from "./remainOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2ac2a2",
  null
  
)

export default component.exports